// extracted by mini-css-extract-plugin
export default {"root":"NavBar-module--root--cbecd","inner":"NavBar-module--inner--0db15","logo":"NavBar-module--logo--1ac49","menuIcon":"NavBar-module--menu-icon--b41ea"};